import { Campaign } from './Campaign';
import { Subscription } from './Subscription';
import { APICall, RequestMethod } from './APICall';
/**
 * constants
 */
const AUTH_TOKEN = 'skhemataToken';
var CampaignFileRegion;
(function (CampaignFileRegion) {
    CampaignFileRegion[CampaignFileRegion["header"] = 1] = "header";
    CampaignFileRegion[CampaignFileRegion["body"] = 2] = "body";
    CampaignFileRegion[CampaignFileRegion["thumbnail"] = 3] = "thumbnail";
    CampaignFileRegion[CampaignFileRegion["top_header"] = 5] = "top_header";
    CampaignFileRegion[CampaignFileRegion["thumbnail_video"] = 6] = "thumbnail_video";
})(CampaignFileRegion || (CampaignFileRegion = {}));
export class Skhemata {
    /**
     *
     * @param apiUrl string
     * @param authToken string
     */
    constructor(apiUrl, authToken) {
        this.api = new APICall(apiUrl, authToken);
        window.addEventListener('skhemata-login', (e) => {
            this.api.authToken = e.detail.authToken;
        });
    }
    /**
     * initialize skhemata api object
     * @returns boolean of auth status
     */
    init() {
        const authToken = localStorage.getItem(AUTH_TOKEN) || undefined;
        return new Promise((resolve) => {
            if (!authToken) {
                resolve(false);
            }
            this.authenticate({ authToken })
                .then(() => resolve(true))
                .catch(() => resolve(false));
        });
    }
    /**
     * authenticate
     * @param auth auth info
     * @returns Promise with api response
     */
    authenticate(auth) {
        const { authToken, email, password } = auth;
        let data;
        if (email && password) {
            data = {
                email,
                password,
            };
        }
        if (authToken) {
            this.api.authToken = authToken;
        }
        const request = {
            requestMethod: data ? RequestMethod.POST : RequestMethod.GET,
            endpoint: 'authenticate',
            data,
        };
        return this.api.send(request)
            .then((res) => {
            this.api.authToken = res.authToken;
            localStorage.set(AUTH_TOKEN, this.api.authToken);
            window.dispatchEvent(new CustomEvent('skhemata-login', {
                detail: {
                    authToken: this.api.authToken,
                },
            }));
            return res;
        });
    }
    logout() {
        this.api.authToken = undefined;
        localStorage.removeItem(AUTH_TOKEN);
        window.dispatchEvent(new CustomEvent('skhemata-logout'));
    }
    /***************
    * Campaign *
    ***************/
    /**
     *
     * @param id ID of the campaign
     * @returns Promise<Campaign>
     */
    getCampaign(id) {
        const campaignRequest = {
            requestMethod: RequestMethod.GET,
            endpoint: `campaign/${id}`,
        };
        const imageRequest = {
            requestMethod: RequestMethod.GET,
            endpoint: `campaign/${id}/resource/file`,
        };
        let newCampaign;
        return this.api.send(campaignRequest)
            .then((campaign) => {
            newCampaign = new Campaign(campaign, this.api);
        })
            .then(() => this.api.send(imageRequest))
            .then((images) => {
            newCampaign.images = images.filter((image) => image.region_id === CampaignFileRegion.thumbnail);
            return newCampaign;
        });
    }
    /**
     *
     * @param data campaign data
     * @returns Promise<Campaign>
     */
    createCampaign(data) {
        const request = {
            requestMethod: RequestMethod.POST,
            endpoint: 'campaign',
            data,
        };
        return this.api.send(request)
            .then((campaign) => new Campaign(campaign, this.api));
    }
    /**
     *  getCampaigns
     * @param params CampaignSearch object
     * @returns Promise with Array of Campaign objects or Error
     */
    getCampaigns(params) {
        const { sort, filter, page } = params;
        const searchParams = new URLSearchParams();
        if (sort) {
            searchParams.set('sort', JSON.stringify(sort));
        }
        if (sort) {
            searchParams.set('filter', JSON.stringify(filter));
        }
        if (page) {
            if (typeof page.page !== undefined) {
                searchParams.set('page', `${page.page}`);
            }
            if (typeof page.page_entries !== undefined) {
                searchParams.set('page_entries', `${page.page_entries}`);
            }
        }
        const request = {
            requestMethod: RequestMethod.GET,
            endpoint: 'campaign',
            searchParams,
        };
        return this.api.send(request)
            .then((res) => res.map((campaign) => new Campaign(campaign, this.api)))
            .catch(() => new Error('Error'));
    }
    /***************
    * SUBSCRIPTION *
    ***************/
    /**
     *
     * @param data data to create the subscription
     * @returns Subscription object
     */
    createSubscription(data) {
        return new Subscription(data, this.api);
    }
}
//# sourceMappingURL=Skhemata.js.map